/*    
<summary>
  This functional component is used for proper authentication of user using the Login Credentials (Username & Password)
  Developer:Aashish Singh, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date: 26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import { Field, Form, Formik } from "formik";
import { useHistory } from 'react-router-dom';
import { observer } from "mobx-react";
import monozlogo from "../../../assets/Images/logo--white.png";
import { useStore } from "../../../contexts/store-provider";
import LoaderButton from "../../../shared-components/button/loader-button";
import FormikFormInput from "../../../shared-components/FormikFormHandlers/FormikFormInput";
import { SendPasswordResetLinkValidationSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import Label from "../../../shared-components/label/label";
import { formatMessage } from "../../../translations/format-message";
import "../login.css";
import RoutesConstants from "../../../constants/routes.constant";
import ResetPasswordWindowPopupHOC from "../../../shared-components/popup/change-password/reset-password-window-popup-hoc";

interface IProps {
  initialValues: any;
  submitHandler: () => void;
}


const ChangePasswordAuthForm = (props: any) => {
  const history = useHistory();
  const { authStore } = useStore();
  const { ResetPasswordAuthLinkService, resetPasswordAuthLinkState } =
    authStore;

  return (
    <>
      {resetPasswordAuthLinkState.inProgress && (
        <FormLoader loading={resetPasswordAuthLinkState.inProgress} />
      )}
      <div className="bg-img1 background">
        <Formik
          initialValues={props.initialValues}
          enableReinitialize
          validationSchema={SendPasswordResetLinkValidationSchema}
          validateOnBlur={false}
          onSubmit={async (values) => {
            props.submitHandler(values);
          }}
        >
          <Form className="change_password-form login">
            <div className="display">
              <div className="logoLogin">
                <figure>
                  <img src={monozlogo} alt="logo" className="img-fluid"></img>
                </figure>
              </div>
              <h1 className="fleet_management_heading">
                {formatMessage("change_password")}
              </h1>
            </div>
            <div className="loginBox">
              <div className=" showHideOuterDiv form-group password_wrapper">
                <Label className="label-style" required={true} label="email" />
                <Field
                  className="form-control "
                  name="Email"
                  type="email"
                  autoComplete="new-email"
                  placeholder="enter_email"
                  validcharacter={["@", "#", "$", "-", "_", "."]}
                  as={FormikFormInput}
                />
              </div>
              <div className="text-center mt-3">
                <LoaderButton
                  type="submit"
                  isLoading={props.loading}
                  text="send_reset_link"
                />
              </div>
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => history.push(RoutesConstants.CustomerLogin)} 
                >
                  {formatMessage("back_to_login")}
                </button>
              </div>
            </div>
          </Form>
        </Formik>
      </div>
    </>
  );
};

export default ResetPasswordWindowPopupHOC(observer(ChangePasswordAuthForm));
